import React from 'react';
import { cn } from '../lib/utils';

export default function LoadingSpinner({ size = 'md', className }) {
  const sizeClasses = {
    sm: 'w-4 h-4',
    md: 'w-8 h-8',
    lg: 'w-12 h-12',
    xl: 'w-16 h-16'
  };

  return (
    <div className={cn('loading-spinner', sizeClasses[size], className)} />
  );
}
